import { UserAction } from "../../../../../ngapp/src/app/user/state/user.action";
angular
    .module("autoremind.account.service", ["pascalprecht.translate"])
    .factory("accountService", [
    "$rootScope",
    "$filter",
    "$http",
    "$enhancedHttp",
    "logger",
    "jobService",
    "dialogs",
    "$q",
    "eventSharingService",
    "authenticationSelectorsDowngraded",
    "storeDowngraded",
    "authenticationActions",
    "angularMomentConfig",
    "userSelectorsDowngraded",
    "$translate",
    "$location",
    function ($rootScope, $filter, $http, $enhancedHttp, logger, jobService, dialogs, $q, eventSharingService, authenticationSelectorsDowngraded, storeDowngraded, authenticationActions, angularMomentConfig, userSelectorsDowngraded, $translate, $location) {
        var service = {};
        var observers = [];
        service.currentUser = undefined;
        service.userPermissionKeys = [];
        service.featurePermissionList = [];
        service.selectedUserPermissionKeys = [];
        service.needReload = false; // TODO: get this value from State
        service.isLoggedIn = false;
        service.sessionTimeout = false;
        service.isAuthenticatedFromAdmin = false;
        service.schedulerState = [
            "active",
            "beta",
            "ar3alpha",
            "ar3beta",
            "ar3active",
        ];
        service.loadingIndicator = { state: false, refCount: 0 };
        authenticationSelectorsDowngraded
            .selectAuthenticate()
            .subscribe(function (authenticate) {
            service.currentUser = authenticate.user;
            console.log("angularJS: service.currentUser:::::  ", service.currentUser);
            service.userPermissionKeys =
                authenticate.user !== undefined
                    ? authenticate.user.userPermissionKeys
                    : [];
            if (authenticate.user !== undefined) {
                $rootScope.$broadcast("event:auth-loginConfirmed");
                service.isLoggedIn = true;
                service.isAuthenticatedFromAdmin =
                    authenticate.isAuthenticatedFromAdmin;
                angularMomentConfig.timezone = authenticate.user.userTimeZone;
                if (service.hasUserPermission("resource:pets")) {
                    $translate.use("en_vets");
                }
                else {
                    $translate.use("en_person");
                }
            }
            if (service.isLoggedIn && authenticate.user === undefined) {
                $rootScope.$broadcast("event:auth-logout");
                service.isLoggedIn = false;
                service.isAuthenticatedFromAdmin = false;
            }
            if (authenticate.isUserAuthenticated) {
                service.sessionTimeout = false;
                service.getUser(service.currentUser.userId, undefined, service.loadingIndicator);
            }
        });
        /**
         * This will delay angularJS route changes until user is logged in (now handled by Angular)
         */
        service.resolveLoginNg1 = function () {
            console.log("resolveLoginNg1: ################# WAITING FOR USER TO RESOLVE ROUTE");
            var deferred = $q.defer();
            // TODO: When changing user we need to clear currentUser for resolve to work
            if (service.currentUser === undefined ||
                service.currentUser.userName === undefined) {
                var loginListener = $rootScope.$on("event:auth-loginConfirmed", function () {
                    loginListener(); // Unsubscribe event
                    return deferred.resolve();
                });
            }
            else {
                console.log("resolveLoginNg1: ################# GOT USER ALREADY", service.currentUser.userName);
                deferred.resolve();
            }
            return deferred.promise;
        };
        service.hasUserPermission = function (permissionKey) {
            //logger.debug('hasUserPermission (' + permissionKey + ')');
            if (service.userPermissionKeys === undefined) {
                return false;
            }
            for (var i = 0; i < service.userPermissionKeys.length; i++) {
                if (service.userPermissionKeys[i] === permissionKey) {
                    return true;
                }
            }
            return false;
        };
        /**
         * --------------------------------
         * SELECTED USER PERMISSIONS SECTION
         * -------------------------------
         */
        userSelectorsDowngraded
            .selectSelectedUserPermissions()
            .subscribe(function (userPermissions) {
            if (userPermissions && userPermissions.length > 0) {
                service.selectedUserPermission = userPermissions;
            }
            else {
                service.selectedUserPermission = [];
            }
        });
        service.selectedUserHasUserPermission = function (permissionKey) {
            if (service.selectedUserPermission === undefined ||
                service.selectedUserPermission === null ||
                service.selectedUserPermission.length === 0) {
                return false;
            }
            for (var i = 0; i < service.selectedUserPermission.length; i++) {
                if (service.selectedUserPermission[i].permissionKey === permissionKey) {
                    return true;
                }
            }
            return false;
        };
        /**
         * --------------------------------
         * END SELECTED USER PERMISSIONS SECTION
         * -------------------------------
         */
        service.timezones = [];
        service.userTypes = [
            "Customer",
            "Demo",
            "Test",
            "Satellite Host",
            "System",
            "Legacy",
            "Autoremind",
            "Reseller",
            "ACTData",
            "Aprima",
            "Ascend",
            "CrystalPM",
            "Daisy",
            "Dentrix",
            "Eaglesoft",
            "Lytec",
            "MacPractice",
            "Medisoft",
            "MicroMD",
            "ModMed",
            "OfficePracticum",
            "OpenDental",
            "PracticePartner",
            "Rev360",
            "Shepherd",
            "SolutionSeries",
            "Tab32",
            "Vetter"
        ];
        service.userStatuses = [
            "Trial",
            "Active",
            "Paused",
            "Cancelled",
            "Stopped"
        ];
        service.partners = [
            "autoremindus",
            "MacPracticepartner",
            "macppartneruk",
            "macaustralia",
            "macpartnercanada",
            "macpartnermx",
            "micromdpartner",
            "mckessonpartner",
            "medcomsyspartner",
            "dmcdental",
            "PracticePartnerPartner",
            "CrystalPMPartner",
            "Rev360Partner"
        ];
        service.selectedUser = null;
        // added to get Selected Users permissions
        service.selectedUserPermission = null;
        // Create list of available max rescheduling options
        service.maxReschedules = []; // [ "1", "2", "3", "9"];
        for (var index = 0; index < 10; index++) {
            service.maxReschedules.push("" + index);
        }
        service.registerObserver = function (callback) {
            // TODO: Refactor to a better way to register each callback function once - or use Observerables?
            observers.push(callback);
        };
        service.notifyObservers = function () {
            observers.forEach(function (callback) {
                callback();
            });
        };
        // Called from Angular 9 services
        userSelectorsDowngraded
            .selectSelectedUser()
            .subscribe(function (user) {
            if (user !== undefined && user.userId !== service.selectedUserId) {
                service.selectedUser = user;
                service.selectedUserId = user.userId;
                service.notifyObservers();
                $location.search("userid", user.userId);
            }
        });
        /*
         service.setSelectedUser = function (userId) {
           service.selectedUserId = userId;
           storeDowngraded.dispatch(UserAction.getSelectedUserById({userId: userId}));
         };
       */
        service.setSelectedUser = function (user) {
            service.selectedUserId = user !== undefined ? user.userId : undefined;
            storeDowngraded.dispatch(UserAction.getSelectedUserByIdSuccess({ selectedUser: user }));
        };
        service.getSelectedUser = function () {
            return service.selectedUser;
        };
        // service.getSelectedUserPermissions = function () {
        //     return service.selectedUserPermission;
        //};
        service.clearModel = function () {
            service.currentUser = null;
        };
        service.searchUser = function (searchPattern, loadingIndicator, disableErrorDialog) {
            return $enhancedHttp({
                method: "GET",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/accounts/users/search/" + searchPattern + "/",
                errorMessage: "Failed searching users on server",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator).then(function (response) {
                return response.users;
            });
        };
        service.checkIfUserExist = function (userName, loadingIndicator, disableErrorDialog) {
            return $enhancedHttp({
                method: "GET",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/accounts/users/exist/" + userName + "/",
                errorMessage: "Failed searching users on server",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator).then(function (response) {
                return response.exist;
            });
        };
        service.getUser = function (userId, userName, loadingIndicator, disableErrorDialog) {
            var url = "/servlets/accounts/users/" +
                (userId ? userId : 0) +
                "/" +
                (userName ? "?user=" + userName : "");
            return $enhancedHttp({
                method: "GET",
                headers: { "Content-Type": "application/json" },
                url: url,
                errorMessage: "Failed searching users on server",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator).then(function (response) {
                if (angular.isDefined(response.hostedByUser)) {
                    response.user.hostedByUser = response.hostedByUser;
                }
                if (angular.isDefined(response.hostedUsers)) {
                    response.user.hostedUsers = response.hostedUsers;
                }
                if (angular.isDefined(response.moduleType)) {
                    response.user.moduleType = response.moduleType;
                }
                response.user.hasStrategies = response.hasStrategies;
                service.selectedUserPermission = response.user.userPermissions;
                return response.user;
            });
        };
        service.setCurrentUser = function (user) {
            service.currentUser = user; // This removed default communications array
            eventSharingService.setCurrentUser(user);
        };
        // return promise for the new user
        service.createUser = function (user, loadingIndicator, disableErrorDialog) {
            // delete userMap["permissionGroup"];
            return $enhancedHttp({
                method: "POST",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/accounts/users/",
                data: user,
                errorMessage: "Failed creating user on server",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator);
        };
        /**
         * Save user data or create new if not created yet.
         * Return promise for the updated/new user
         */
        service.saveUser = function (user, loadingIndicator, disableErrorDialog) {
            var userId = user.userId;
            // Remove details not needed by backend
            var userCopy = angular.copy(user);
            delete userCopy.userPermissions;
            delete userCopy.permissionGroup;
            if (!userId) {
                return service.createUser(userCopy);
            }
            /**
             * If user has already created then is possible to save features
             */
            userCopy.permissions = service.featurePermissionList;
            return $enhancedHttp({
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/accounts/users/" + userId + "/",
                data: userCopy,
                errorMessage: "Failed saving user on server",
                disableErrorDialog: disableErrorDialog,
                returnHttpResponseOnFail: true,
                handleStatus: 409,
            }, loadingIndicator).then(function (response) {
                return response; // TODO: Remove since not necessary step
            });
        };
        // First item is default
        service.emailDevices = [
            {
                label: "smtp1",
                value: "email|smtp1|0",
            },
            {
                label: "simulator",
                value: "email|simulator1|0",
            },
        ];
        // Default will be selected based on user's mcc (country)
        service.smsDevices = [
            {
                label: "infobip",
                value: "sms|infobip|0",
            },
            {
                label: "m4u",
                value: "sms|m4u|505",
            },
            {
                label: "messagemedia",
                value: "sms|messagemedia|0",
            },
            {
                label: "twilio",
                value: "sms|twilio|0",
            },
            {
                label: "igms",
                value: "sms|igms|0",
            },
            {
                label: "simulator",
                value: "sms|ipxsimulator|0",
            },
        ];
        // First item is default
        service.voiceDevices = [
            {
                label: "pnova",
                value: "voice|pnova|0",
            },
        ];
        // NOTE: Still used by preview-edit-template.directive
        service.defaultMedia = [
            {
                type: "email",
                device: "email|smtp1|0",
                templateFragment: "mailcontent",
            },
            {
                type: "sms",
                device: "sms|infobip|0",
                templateFragment: "smscontent",
            },
            {
                type: "voice",
                device: "voice|pnova|0",
                templateFragment: "voicecontent",
            },
        ];
        /**
         * Get device by country
         */
        service.getSMSDeviceByCountry = function (mmc) {
            var device;
            switch (mmc * 1) {
                case 505: // Australia
                    device = "sms|m4u|505";
                    break;
                case 310: // USA
                    device = "sms|infobip|0";
                    break;
                case 302: // Canada
                    device = "sms|twilio|0";
                    break;
                default:
                    // rest
                    device = "sms|twilio|0";
                    break;
            }
            return device;
        };
        service.getDefaultDevice = function (type, mmc) {
            var defaultDevice;
            switch (type) {
                case "email":
                    defaultDevice = service.emailDevices[0].value;
                    break;
                case "voice":
                    defaultDevice = service.voiceDevices[0].value; // TODO: Move pnova as first
                    break;
                case "sms":
                    defaultDevice = service.smsDevices[0].value; // TODO: Select by country
                    defaultDevice = service.getSMSDeviceByCountry(mmc);
                    break;
            }
            return defaultDevice;
        };
        service.getUserCommunications = function (userInfo, loadingIndicator, disableErrorDialog, isForCommunication) {
            //return service.getUser(userId, loadingIndicator, disableErrorDialog)
            return $enhancedHttp({
                method: "GET",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/accounts/users/" + userInfo.userId + "/communication/",
                errorMessage: "Failed searching users on server",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator).then(function (response) {
                //var communication = response.communication;
                if (response.communication === undefined ||
                    response.communication === null) {
                    userInfo.communication = {
                        // TODO: Consider setting defaults either in servlet or in jobService
                        categories: isForCommunication
                            ? []
                            : angular.copy(jobService.availableCategories),
                        // TODO: If defined already but availableCategories has changed then make sure the user's list has all (and only those) in availableCategories
                        credit: {
                            max: "",
                            warning: "",
                        },
                        price: {
                            sms: "",
                            voice: "",
                        },
                        included: {
                            sms: "",
                            voice: "",
                        },
                    };
                }
                else {
                    userInfo.communication = response.communication;
                    if (response.communication.categories === undefined ||
                        response.communication.categories === null) {
                        userInfo.communication.categories = angular.copy(jobService.availableCategories);
                    }
                    // TODO: If list exists but does not include all available categories then add those missing so it's still possible to edit
                }
                if (response.account === undefined || response.account === null) {
                    //userInfo.voiceCompanyIntro = '';
                    //userInfo.voiceCompanyOutro = '';
                    //userInfo.media = service.defaultMedia;
                }
                else {
                    //userInfo.voiceCompanyIntro = response.account.voiceCompanyIntro || '';
                    //userInfo.voiceCompanyOutro = response.account.voiceCompanyOutro || '';
                    userInfo.media = response.account.media; // || service.defaultMedia;
                }
                userInfo.account = response.account;
                return userInfo;
            });
        };
        service.saveUserCommunication = function (userInfo, loadingIndicator) {
            var deferred = $q.defer();
            userInfo.account.media = userInfo.account.media || userInfo.media;
            var requestData = {
                communication: userInfo.communication,
                account: userInfo.account,
                autoremindAccount: userInfo.userName,
            };
            var disableActiveJobs = function (confirmed) {
                var confirmation = "";
                if (confirmed) {
                    confirmation = "?confirmed=true";
                }
                $enhancedHttp({
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    url: "/servlets/jobs/disableactive/" +
                        userInfo.userId +
                        "/" +
                        confirmation,
                    data: requestData,
                    errorMessage: "Failed saving user communication settings on server",
                }, loadingIndicator).then(function (response) {
                    if (response.activeJobsToDisable.length > 0 && !confirmed) {
                        service
                            .confirmSavingUserCommunication(response.activeJobsToDisable)
                            .then(function () {
                            disableActiveJobs(true);
                        }, function () {
                            deferred.reject();
                        });
                    }
                    else {
                        saveUserCommunication();
                    }
                }, function () {
                    deferred.reject();
                });
            };
            var saveUserCommunication = function () {
                $enhancedHttp({
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    url: "/servlets/accounts/users/" +
                        userInfo.userId +
                        "/communication/",
                    data: requestData,
                    errorMessage: "Failed saving user communication settings on server",
                }, loadingIndicator).then(function (response) {
                    deferred.resolve(response);
                }, function () {
                    deferred.reject();
                });
            };
            disableActiveJobs();
            return deferred.promise;
        };
        service.confirmSavingUserCommunication = function (activeJobsToDisable) {
            var deferred = $q.defer();
            var categories = [];
            var msg = "The selected user has active automated jobs that will be disabled for these categories (";
            for (var i in activeJobsToDisable) {
                if (categories.indexOf(activeJobsToDisable[i].jobCategory) > -1) {
                    continue;
                }
                categories.push(activeJobsToDisable[i].jobCategory);
                msg += $filter("i18n")("_communicationsCategory_" +
                    activeJobsToDisable[i].jobCategory +
                    "_");
                if (i < activeJobsToDisable.length - 1) {
                    msg += ", ";
                }
            }
            msg += "). Are you sure you wish to disable these categories?";
            dialogs.confirm("Confirmation dialog", msg).result.then(function () {
                deferred.resolve();
            }, function () {
                deferred.reject();
            });
            return deferred.promise;
        };
        service.deleteUser = function (userId, loadingIndicator, disableErrorDialog) {
            return $enhancedHttp({
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/accounts/users/" + userId + "/",
                errorMessage: "Failed deleting user on server",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator);
        };
        service.getTimezones = function (loadingIndicator, disableErrorDialog) {
            return $enhancedHttp({
                method: "GET",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/accounts/timezones/",
                errorMessage: "Failed deleting user on server",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator).then(function (response) {
                var sortableTimezones = [];
                for (var i = 0; i < response.timezones.length; i++) {
                    var key = response.timezones[i].displayName !== undefined ? response.timezones[i].displayName : response.timezones[i].tzKey;
                    sortableTimezones.push({ key: key, value: response.timezones[i].tzKey, disable: response.timezones[i].obsolete !== undefined });
                }
                service.timezones = sortableTimezones;
                return service.timezones;
            });
        };
        /**
         * Convert Autoremind start/stop interval date (set in UI) to time string or set to provided default of no interval.
         * The start/stop interval is set as a time string in Autoremind.
         */
        service.dateToInterval = function (interval, defaultValue) {
            if (interval) {
                var hours = interval.getHours();
                if (hours < 10) {
                    hours = "0" + hours;
                }
                var minutes = interval.getMinutes();
                if (minutes === 0) {
                    minutes = "00";
                }
                else {
                    if (minutes < 10) {
                        minutes = "0" + minutes;
                    }
                }
                return "" + hours + ":" + minutes;
            }
            else {
                return defaultValue;
            }
        };
        /**
         * Convert Autoremind start/stop interval to a JavaScript Date.
         */
        service.intervalToDate = function (interval, defaultHour) {
            if (interval === undefined || interval === null) {
                interval = defaultHour;
            }
            // var converter = moment(interval, 'HH:mm');
            var converter = new Date();
            converter.setHours(interval.substring(0, 2), interval.substring(3));
            return converter; // .toDate();
        };
        // ---------- Permission methods and model ----------
        // TODO: Still consider moving this to a permissionService or rename usersService to accountService?
        service.permissions = [];
        service.permissionGroups = [];
        service.getPermissions = function (loadingIndicator, disableErrorDialog) {
            return $enhancedHttp({
                method: "GET",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/accounts/permissions/",
                errorMessage: "Failed getting permissions from server",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator).then(function (response) {
                service.permissions = response.permissions;
                return response; // TODO: Skip sending response back?
            });
        };
        service.getPermissionGroups = function (loadingIndicator, disableErrorDialog) {
            return $enhancedHttp({
                method: "GET",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/accounts/permissions/groups/",
                errorMessage: "Failed getting permission groups from server",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator).then(function (response) {
                service.permissionGroups = response.permissionGroups; // TODO: Change backend to return permissionGroups
                return response; // TODO: Skip sending response back?
            });
        };
        // Moved from permissions.controller - TODO: move to service or component?
        service.getPermissionGroupIndex = function (permissionGroupId) {
            if (service.permissionGroups === undefined) {
                return -1;
            }
            // Find index of this permissionGroupId in the permissionGroup list
            for (var i = 0; i < service.permissionGroups.length; i++) {
                if (service.permissionGroups[i].permissionGroupId === permissionGroupId) {
                    return i;
                }
            }
            return -1; // not found
        };
        // TODO: Change to just send group object by reference? and update group with new groupId?
        service.addPermissionGroup = function (groupName, groupDescription, loadingIndicator, disableErrorDialog) {
            var postData = {
                groupName: groupName,
                groupDescription: groupDescription,
            };
            return $enhancedHttp({
                method: "POST",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/accounts/permissions/groups/",
                data: JSON.stringify(postData),
                errorMessage: "Failed adding permission group on server",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator);
        };
        /**
         * Update group name and description for group with specified groupId
         */
        service.updatePermissionGroup = function (group, loadingIndicator, disableErrorDialog) {
            var now = new Date();
            var postData = {
                groupName: group.permissionGroupName,
                groupDescription: group.permissionGroupDescription,
                modifiedInt: now.getTime(),
            };
            return $enhancedHttp({
                method: "POST",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/accounts/permissions/groups/" +
                    group.permissionGroupId +
                    "/",
                data: JSON.stringify(postData),
                errorMessage: "Failed updating permission group on server",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator).then(function (response) {
                if (response.permissionGroup !== undefined) {
                    // Update group with latest values from database (in case updated by another user or session)
                    group.permissionGroupName =
                        response.permissionGroup.permissionGroupName;
                    group.permissionGroupDescription =
                        response.permissionGroup.permissionGroupDescription;
                    group.permissionGroupModifiedInt =
                        response.permissionGroup.permissionGroupModifiedInt;
                }
            });
        };
        service.addPermissionToGroup = function (permissionGroupId, permissionId, loadingIndicator, disableErrorDialog) {
            return $enhancedHttp({
                method: "POST",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/accounts/permissions/groups/" +
                    permissionGroupId +
                    "/" +
                    permissionId +
                    "/",
                errorMessage: "Failed adding permission to group on server",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator);
        };
        service.removePermissionFromGroup = function (permissionGroupId, permissionId, loadingIndicator, disableErrorDialog) {
            return $enhancedHttp({
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/accounts/permissions/groups/" +
                    permissionGroupId +
                    "/" +
                    permissionId +
                    "/",
                errorMessage: "Failed removing permission from group on server",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator);
        };
        service.getPermissionIndexInGroup = function (permissionGroupIndex, permissionId) {
            // Find index of this permissionId in the permission group
            // Note: permissionId is different from its index in a group
            // Note; called with permissionGroupIndex (the index) - not permissionGroupId
            for (var i = 0; i < service.permissionGroups[permissionGroupIndex].permissions.length; i++) {
                if (service.permissionGroups[permissionGroupIndex].permissions[i]
                    .permissionId === permissionId) {
                    return i;
                }
            }
            return -1; // not found
        };
        service.addPermissionToGroupModel = function (permissionGroupId, permissionId) {
            var permissionGroupIndex = service.getPermissionGroupIndex(permissionGroupId);
            if (permissionGroupIndex < 0) {
                dialogs.error("Error", "Selected permission group not found");
                return;
            }
            // Test if permission group already has this permission
            if (service.getPermissionIndexInGroup(permissionGroupIndex, permissionId) >= 0) {
                // this permission is already in the group, do nothing
                return;
            }
            // NOTE: It may seem a bit backward that we select an index in the selectmenu - find the permissionId and then send it here
            //       where we then find the permission index. And it is - but in the end we will only need the permissionId and send it
            //       directly to the backend and then update the view.
            // Find index of this permissionId
            var permissionIndex = -1;
            for (var i = 0; i < service.permissions.length; i++) {
                if (service.permissions[i].permissionId === permissionId) {
                    permissionIndex = i;
                }
            }
            if (permissionIndex < 0) {
                dialogs.error("Error", "Selected permission not found");
                return;
            }
            // Finally add the permission to the group by copying it into the permission list
            service.permissionGroups[permissionGroupIndex].permissions.push(service.permissions[permissionIndex]);
            // TODO: send request to backend to change the permission
            // TODO: it would be a good idea to reload the permissions from the server to make sure it got the message
        };
        service.removePermissionFromGroupModel = function (permissionGroupId, permissionId) {
            var permissionGroupIndex = service.getPermissionGroupIndex(permissionGroupId);
            if (permissionGroupIndex < 0) {
                dialogs.error("Error", "Selected permission group " +
                    permissionGroupId +
                    " not found for removePermission");
                return;
            }
            // get permissions index in this group
            var permissionIndex = service.getPermissionIndexInGroup(permissionGroupIndex, permissionId);
            if (permissionIndex < 0) {
                dialogs.error("Error", "Selected permission " + permissionId + " not found");
                return;
            }
            service.permissionGroups[permissionGroupIndex].permissions.splice(permissionIndex, 1);
            // TODO: send request to backend to change the permission
            // TODO: it would be a good idea to reload the permissions from the server to make sure it got the message
        };
        service.getPermissionIndexWithKey = function (permissionKey) {
            for (var i = 0; i < service.permissions.length; i++) {
                if (service.permissions[i].permissionKey === permissionKey) {
                    return i;
                }
            }
            return -1;
        };
        service.getPermissionChildren = function (parentIdx) {
            var permissionIndexList = [];
            if (service.permissions === undefined) {
                return permissionIndexList;
            }
            // Find all permissions that has this one as parent
            for (var i = 0; i < service.permissions.length; i++) {
                var permissionKey = service.permissions[i].permissionKey;
                var n = permissionKey.lastIndexOf(":");
                if (n === -1) {
                    // This has no parents
                    if (parentIdx === -1) {
                        permissionIndexList.push(i);
                    }
                }
                else {
                    // Find the parent
                    var parentKey = permissionKey.substring(0, n);
                    if (service.getPermissionIndexWithKey(parentKey) === parentIdx) {
                        permissionIndexList.push(i);
                    }
                }
            }
            return permissionIndexList;
        };
        /**
         * Check if given user has given permission
         */
        service.hasPermission = function (user, permission) {
            if (user.permissionGroup !== undefined && user.permissionGroup !== null) {
                var permissions = user.permissionGroup.permissions;
                for (var index in permissions) {
                    if (permissions[index].permissionKey === permission) {
                        return true;
                    }
                }
            }
            return false;
        };
        // -------- End of permission methods
        //TODO: Move to centralService or userProfile
        service.accountSettings = null;
        service.accountSettingsOff = true;
        service.saveAccountSettings = function (testCount, statusToSatellite, statusFromSatellite, strategyId, countryPhonePrefix) {
            service.accountSettings = {
                testCount: testCount,
                statusToSatellite: statusToSatellite,
                statusFromSatellite: statusFromSatellite,
                strategyId: strategyId,
                countryPhonePrefix: countryPhonePrefix,
            };
            logger.debug("accountService: Saving account settings (statusToSatellite=" +
                statusToSatellite +
                ", statusFromSatellite=" +
                statusFromSatellite +
                ", strategyId=" +
                strategyId +
                ", countryPhonePrefix=" +
                countryPhonePrefix +
                ")");
            return $http.post("/servlets/strategies/?account=true", JSON.stringify(service.accountSettings));
        };
        service.setAccountSchedulerState = function (userId, schedulerState) {
            logger.debug("accountService.setAccountSchedulerState: Saving account schedulerState");
            //return $http.post('/servlets/strategies/?account=true', JSON.stringify(service.accountSettings) );
            var data = {
                accountScheduler: service.accountSettings.accountScheduler,
            };
            return $enhancedHttp({
                method: "POST",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/central/accounts/" +
                    userId +
                    "/schedulerstate/" +
                    schedulerState +
                    "/",
                data,
            }).then(function (response) {
                logger.debug("accountService.setAccountSchedulerState(): Successful saving account settings to server");
                service.accountSettings = response.settings;
                return response;
            });
        };
        //service.wipeAccount = function (userName, data, cb) {
        service.wipeAccount = function (userId, userName, resourcesToWipe, loadingIndicator, disableErrorDialog) {
            return $enhancedHttp({
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/central/accounts/" + userId + "/wipe/",
                data: resourcesToWipe,
                errorMessage: "Failed deleting account data on server",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator).then(function (data) {
                logger.debug("accountService.wipeAccount(): Successful deleting account data on server");
                dialogs.notify($filter("i18n")("_dialogHeaderSuccess_"), "Selected data in the Central database have been wiped for " +
                    userName +
                    "! Remember to Resume in Central Scheduler when needed.");
                return data;
            });
        };
        service.resetAR2 = function (userId, userName, loadingIndicator, disableErrorDialog) {
            return $enhancedHttp({
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/central/accounts/" + userId + "/resetar2/",
                errorMessage: "Failed resetting AR2",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator).then(function (data) {
                logger.debug("accountService.resetAR2(): Successful resetting AR2");
                dialogs.notify($filter("i18n")("_dialogHeaderSuccess_"), "Autoremind2 has been factory reset for " +
                    userName +
                    "!" +
                    "<br/><br/>Deleted: " +
                    data.deleted +
                    "<br/><br/>Remember to Resume in Central Scheduler when needed.");
                return data;
            });
        };
        service.getAccountSettings = function (userId, loadingIndicator, disableErrorDialog) {
            var url = "/servlets/central/accounts/";
            if (userId !== null) {
                url += userId + "/";
            }
            return $enhancedHttp({
                method: "GET",
                headers: { "Content-Type": "application/json" },
                url: url,
                errorMessage: "Failed getting account settings from server",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator).then(function (data) {
                logger.debug("accountService.getAccountSettings(): Successful getting account settings from server");
                service.accountSettings = data.settings;
                return data.settings;
            });
        };
        service.updateAccountSettings = function (userId, loadingIndicator, disableErrorDialog) {
            return $enhancedHttp({
                method: "POST",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/central/accounts/update/" + userId + "/",
                errorMessage: "Failed updating account settings from server",
                disableErrorDialog: disableErrorDialog,
            }, loadingIndicator).then(function (data) {
                logger.debug("accountService.updateAccountSettings(): Successful updating account settings from server");
                service.accountSettings = data.settings;
                return data.settings;
            });
        };
        service.getCentralDataStats = function (userId) {
            return $enhancedHttp({
                method: "GET",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/central/accounts/stats/?userid=" + userId,
            }).then(function (response) {
                logger.debug("accountService.getCentralDataStats(): Successful getting account stats from server");
                return response.stats;
            });
            /*.error(function(data, status) {
                                logger.error('Error getting account settings from server');
                            })*/
        };
        service.getAutoremind2PermissionsByUserName = function (userName, loadingIndicator) {
            return $enhancedHttp({
                method: "GET",
                headers: { "Content-Type": "application/json" },
                url: "servlets/ar2/permissions/" + userName + "/",
                errorMessage: "Failed getting ar2 permissions",
                disableErrorDialog: false,
            }, loadingIndicator).then(function (result) {
                return result.permissions;
            });
        };
        /**
         * Permit the user by <permission> access
         * @param userName
         * @param loadingIndicator
         */
        service.setUserToAutoremind2Permission = function (userName, permission, loadingIndicator) {
            return $enhancedHttp({
                method: "POST",
                headers: { "Content-Type": "application/json" },
                url: "servlets/ar2/permissions/" + userName + "/" + permission + "/",
                errorMessage: "Failed setting a [" +
                    permission +
                    "] permissions to user [" +
                    userName +
                    "]",
                disableErrorDialog: false,
            }, loadingIndicator);
        };
        service.addPermission = function (permissionKey, permissionName, permissionDescription, loadingIndicator) {
            var permission = { permissionKey: permissionKey,
                permissionName: permissionName,
                permissionDescription: permissionDescription };
            return $enhancedHttp({
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                url: "/servlets/permission/",
                data: { permission },
                errorMessage: "Failed creating Permission"
            }, loadingIndicator).then(function (result) {
                return result;
            });
        };
        $rootScope.$on("event:auth-logout", function () {
            logger.debug("accountService.clear: killing service data");
            service.clearModel();
        });
        $rootScope.$on("event:session-timeout", function () {
            logger.debug("accountService:::session-timeout:::");
            if (!service.sessionTimeout) {
                service.sessionTimeout = true;
                eventSharingService.sessionTimeOut();
            }
        });
        return service;
    },
]);
angular
    .module("autoremind.account.service")
    .controller("LangCtrl", function ($scope, $translate) {
    $scope.changeLang = function (key) {
        $translate.use(key).then(function (key) {
            if (key === "vets") {
                console.log("Sprache zu " + key + " gewechselt.");
            }
            else {
                console.log("NOT " + key);
            }
        }, function (key) {
            console.log("HETRE HERE");
        });
    };
});
//# sourceMappingURL=account.service.js.map